import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Cache } from 'aws-amplify';
import { UserSettingsHttpService } from '../../user-settings';

@Component({
  selector: 'kt-client-dialog',
  templateUrl: './client-dialog.component.html',
  styleUrls: ['./client-dialog.component.scss']
})
export class ClientDialogComponent implements OnInit {

	selectedDisti = null;
	selectedMarket = null;
	selectedClient = null;
	selectedCampus = null;

	noDisti = false;
	noMarket = false;
	noClient = false;
	noCampus = false;

	showUnassigned = false;

	distis ;
	markets ;
	clients ;
	campuses ;

	user;
	role = null;
	showTill;

  constructor(public dialogRef: MatDialogRef<ClientDialogComponent>,
			@Inject(MAT_DIALOG_DATA) public data: any,
  			private userSettingshttp: UserSettingsHttpService,
			private router: Router) { }

  ngOnInit() {
	this.user = Cache.getItem('userAttr');
	this.role = this.user['custom:role'];
	console.log(this.data);

	// Set showUnassigned based on data passed, default to false
	if(this.data && this.data.hasOwnProperty('showUnassigned')) {
		this.showUnassigned = this.data.showUnassigned;
	}

		// If user is distiadmin, auto-set distributor but respect requested level
		if(this.role == 'distiadmin'){
			this.selectedDisti = {disti_id: this.user['custom:disti_id'], name: this.user['custom:disti_name']};
			if(this.data && this.data.show == 'market'){
				this.getMarkets();
			} else if(this.data && this.data.show == 'client'){
				if(this.data.market){
					this.selectedMarket = this.data.market;
				}
				this.getClients();
			} else if(this.data && this.data.show == 'campus' && this.data.client){
				if(this.data.market){
					this.selectedMarket = this.data.market;
				}
				this.selectedClient = this.data.client;
				this.getCampus({client_id: this.data.client.client_id,disti_id: this.selectedDisti.disti_id || null});
			} else {
				// default for distiadmin is markets list
				this.getMarkets();
			}
		} else if(this.data && this.data.show == 'disti'){
		this.getDistributors();
	} else if(this.data && this.data.show == 'market') {
		if(!this.data.disti || !this.data.disti.disti_id){
			// No distributor selected, show error and go back to distributor selection
			this.selectedDisti = null;
			this.getDistributors();
		} else {
			this.selectedDisti = this.data.disti;
			this.getMarkets();
		}
	} else if(this.data && this.data.show == 'client' && this.data.disti) {
		this.selectedDisti = this.data.disti;
		if(this.data.market){
			this.selectedMarket = this.data.market;
		}
		this.getClients();
	} else if(this.data && this.data.show == 'campus' && this.data.client) {
		if(this.data.disti){
			this.selectedDisti = this.data.disti;
		}
		if(this.data.market){
			this.selectedMarket = this.data.market;
		}
		this.selectedClient = this.data.client;
		this.getCampus({client_id: this.data.client.client_id,disti_id: this.selectedDisti.disti_id || null});
	} else {
		this.getDistributors();
	}
  }

  getDistributors() {
	this.noDisti = false;
		if(this.role == 'sadmin') {
			this.userSettingshttp.getDistis()
			.subscribe((distis: any[]) => {
				this.distis = distis;
				if(distis.length){
					if(this.data.all){
						if(this.showUnassigned){
							this.distis.unshift({name: "Unassigned", disti_id: 'unassigned'});
						}

						this.distis.unshift({name: "All", disti_id: null});
					}
				}else{
					this.noDisti = true;
				}
			});
		} else {
			console.log(this.user);
			this.distis = (this.user['custom:disti_id']).split(',');
		}
	}

getClients() {
	this.noClient = false;
	if (this.role.includes('admin')) {
		const params: any = {};
		if(this.selectedDisti && this.selectedDisti.disti_id != null){
			params.disti_id = this.selectedDisti.disti_id;
		}
		if(this.selectedMarket){
			params.market_id = this.selectedMarket.market_id;
		}
		this.userSettingshttp.getClients(params)
		.subscribe((clients: any[]) => {
			this.clients = clients;
			if(clients.length){
				if(this.data.all)
				this.clients.unshift({company_name: "All", client_id: null})
			}else{
				this.noClient = true;
			}

		});
	} else {
		this.clients = (this.user['custom:client_id']).split(',');
		this.getCampus({client_id: this.selectedClient.client_id, disti_id: this.selectedDisti.disti_id});
	}
}

getCampus(campus) {
	this.noCampus = false;
	console.log("campus:",campus);

	this.userSettingshttp.getCampus(campus)
	.subscribe((campuses: any[]) => {
		this.campuses = campuses;
		if(campuses.length){
			if(this.data.all)
			this.campuses.unshift({name: "All", campus_id: null});
		}else{
			this.noCampus = true;
		}
	});
}

  onDisti(obj){
	this.selectedDisti = obj;
	if(obj.disti_id == 'unassigned'){
		this.dialogRef.close();
		this.router.navigate(['register-machine']);
	}
	if(this.data && this.data.showTill == 'disti'){
		this.dialogRef.close({success: true, data: {disti: this.selectedDisti}});
	} else if(obj.disti_id == null){
		// If distributor is 'All', skip market step and go to clients
		this.getClients();
	} else {
		this.getMarkets();
	}
  }

  getMarkets() {
	this.noMarket = false;
	const params = { disti_id: this.selectedDisti.disti_id };
	this.userSettingshttp.getMarkets(params)
	.subscribe((response: any) => {
		this.markets = response;
		if(this.markets && this.markets.length){
			if(this.data.all){
				this.markets.unshift({market_name: "All", market_id: null});
			}
		}else{
			this.noMarket = true;
		}
	});
  }

  onMarket(obj){
	this.selectedMarket = obj;
	if(this.data && this.data.showTill == 'market'){
		this.dialogRef.close({success: true, data: {market: this.selectedMarket}});
	}else{
		this.getClients();
	}
  }

  onClient(obj){
	this.selectedClient = obj;
	console.log(this.data.showTill,"this.data.showTill == 'client':",this.data.showTill == 'client');

	if(this.data && this.data.showTill == 'client'){
		this.dialogRef.close({success: true, data: {client: this.selectedClient}});
	}else{
		const campusParams: any = {client_id: this.selectedClient.client_id};
		if(this.selectedDisti && this.selectedDisti.disti_id != null){
			campusParams.disti_id = this.selectedDisti.disti_id;
		}
		this.getCampus(campusParams);
	}

  }

  onCampus(obj){
	this.selectedCampus = obj;
	if(this.data.bckBtn){
		this.dialogRef.close({success: true, data: {disti: this.selectedDisti, market: this.selectedMarket, client: this.selectedClient,campus: this.selectedCampus}});
	}else{
		this.dialogRef.close({success: true, data: {campus: this.selectedCampus}});
	}

  }

  onBack(txt){
	if (txt == 'disti'){
		this.selectedCampus = null;
		this.selectedClient = null;
		this.selectedMarket = null;
		this.selectedDisti = null;
	} else if(txt == 'market') {
		this.selectedCampus = null;
		this.selectedClient = null;
		this.selectedMarket = null;
	} else if(txt == 'client') {
		this.selectedCampus = null;
		this.selectedClient = null;
	}
  }

}

